import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const ChevronLeft = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 12 20"
          fill="none"
          ref={ref}
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.40588 3.64204L11.3985 0.879602L10.5866 0L7.59394 2.76244L8.40588 3.64204ZM2.26316 9.31224L7.50809 4.47078L6.69615 3.59117L0.569015 9.24699L10.554 20L11.4312 19.1855L2.26316 9.31224Z"
            fill="currentcolor"
          />
        </svg>
      </Icon>
    );
  },
);

ChevronLeft.displayName = "ChevronLeft";
